export default function (injection, Vue) {
    const util = {
        displayInCenter (img, dom) {
            let w = img.width;
            let h = img.height;
            let pw = dom.offsetWidth;
            let iw, ih;
            if (w < pw && h < pw) {
                img.style.marginTop = (pw - h) / 2 + 'px'
                img.style.marginLeft = (pw - w) / 2 + 'px'
            } else {
                if (w > h) {
                    iw = pw;
                    ih = h / w * iw;
                    img.style.marginTop = (iw - ih) / 2 + 'px';
                    img.style.marginBottom = (iw - ih) / 2 + 'px';
                } else {
                    ih = pw;
                    iw = w / h * ih;
                    img.style.marginLeft = (ih - iw) / 2 + 'px';
                }
                img.width = iw;
                img.height = ih;
            }
            dom.appendChild(img);
        }
    }
    Object.defineProperties(injection, {
        image: {
            get () {
                return util;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $image: {
            get () {
                return util;
            }
        }
    });
}
